import controller from './kid.controller';
import template from './kid.html';

export default {
	template,
	bindings: {
		disabled:    '<?ngDisabled',
		placeholder: '@?',
		prefix:      '@?',
		required:    '<?ngRequired',
		onSelect:    '&?',
		options:     '<?',
	},
	controller,
	require:  {
		ngModelCtrl: '?ngModel',
	},
};
